// extracted by mini-css-extract-plugin
export var cardIcon = "_al-5";
export var cardIconUnframed = "_al-9";
export var checkboxCard = "_al-0";
export var checkboxCardSelected = "_al-4";
export var disabled = "_al-2";
export var interactive = "_al-1";
export var outerBorder = "_al-3";
export var spacerMedium = "_al-8";
export var spacerSmall = "_al-7";
export var spacerXsmall = "_al-6";